<template>
  <footer class="bg-body-tertiary py-5 mt-5 border-top">
    <div class="container text-center">
      <!-- Iconos de Redes Sociales -->
      <div class="d-flex justify-content-center gap-3 mb-4">
        <a
          v-for="red in redesSociales"
          :key="red.nombre"
          :href="red.url"
          target="_blank"
          rel="noopener noreferrer"
          class="social-icon fs-3"
          :style="{ color: red.color }"
          :title="red.nombre"
        >
          <i :class="['bi', red.icono]"></i>
        </a>
      </div>

      <p class="text-muted mb-0">
        &copy; {{ anioActual }} - Desarrollado con <strong>Vue 3</strong> y <strong>Bootstrap 5</strong>
      </p>
    </div>
    <a
      href="https://wa.me/56993162215"
      class="btn btn-success rounded-circle shadow position-fixed end-0 me-2 me-md-4 p-3 floating-btn floating-btn-whatsapp"
      target="_blank"
      rel="noopener noreferrer"
      title="WhatsApp"
    >
      <i class="bi bi-whatsapp fs-4"></i>
    </a>

    <a
      href="https://linkedin.com/in/sergio-espinosa-bb114948"
      class="btn btn-primary rounded-circle shadow position-fixed end-0 me-2 me-md-4 p-3 floating-btn floating-btn-linkedin"
      target="_blank"
      rel="noopener noreferrer"
      title="LinkedIn"
    >
      <i class="bi bi-linkedin fs-4"></i>
    </a>

    <a
      href="https://github.com/sergioespinosae-ux"
      class="btn btn-dark rounded-circle shadow position-fixed end-0 me-2 me-md-4 p-3 floating-btn floating-btn-github"
      target="_blank"
      rel="noopener noreferrer"
      title="GitHub"
    >
      <i class="bi bi-github fs-4"></i>
    </a>
  </footer>
</template>

<script setup>
import { ref } from 'vue';

const anioActual = new Date().getFullYear();

const redesSociales = ref([
  { nombre: 'GitHub', url: 'https://github.com/sergioespinosae-ux', icono: 'bi-github', color: '#333' },
  { nombre: 'LinkedIn', url: 'https://linkedin.com/in/sergio-espinosa-bb114948', icono: 'bi-linkedin', color: '#0077b5' },
  { nombre: 'WhatsApp', url: 'https://wa.me/56993162215', icono: 'bi-whatsapp', color: '#25D366' }
]);
</script>

<style scoped>
.social-icon {
  transition: transform 0.3s ease, color 0.3s ease;
}

.social-icon:hover {
  transform: translateY(-5px);
  color: var(--bs-primary) !important;
}

.floating-btn {
  z-index: 1000;
  transition: transform 0.25s ease;
}

.floating-btn:hover {
  transform: translateY(-4px);
}

.floating-btn-whatsapp {
  bottom: 1rem;
}

.floating-btn-linkedin {
  bottom: 5.5rem;
}

.floating-btn-github {
  bottom: 10rem;
}

</style>